import React from 'react';
import { Alert, styled } from '@mui/material';
import type { AlertProps } from '@mui/material';
import { Colors } from '../../theme';

const SEVERITY_COLORS: Record<string, { background: Colors; icon: Colors }> = {
    info: { background: Colors.lightTurq, icon: Colors.darkNavy },
    success: { background: Colors.lightGreen, icon: Colors.darkNavy },
    warning: { background: Colors.lightWarning, icon: Colors.darkNavy },
    error: { background: Colors.lightRed, icon: Colors.mediumRed },
};

const StyledAlert = styled(Alert)<{ severity?: string }>(({ severity = 'info' }) => {
    const colors = SEVERITY_COLORS[severity] ?? SEVERITY_COLORS.info;
    return {
        borderRadius: 8,
        backgroundColor: colors.background,
        '& .MuiAlert-message': {
            fontFamily: 'Outfit',
        },
        '& .MuiAlert-icon': {
            color: colors.icon,
        },
    };
});

export default function InlineAlert(props: AlertProps) {
    return <StyledAlert {...props} />;
}
